import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

const LABELS = {
  licence: "Driver's Licence", badge: "Private Hire Driver Badge", insurance: "Hire & Reward Insurance",
  vehicle_licence: "Private Hire Vehicle Licence", right_to_work: "Right to Work", dbs: "DBS Check", mot: "MOT Certificate",
};
const WARN_DAYS = 7;

const daysUntil = (iso) => {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const exp = new Date(`${iso}T00:00:00`);
  return isNaN(exp.getTime()) ? null : Math.round((exp - today) / 86400000);
};

// Approved mandatory docs that expire within 7 days (or already have), with a Renew shortcut.
export const DocumentExpiryBanner = ({ onRenew, refreshKey }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/driver/documents").then((res) => {
      if (!alive) return;
      const list = (Array.isArray(res.data) ? res.data : [])
        .filter((d) => d.status === "approved" && d.expiry_date && LABELS[d.doc_type])
        .map((d) => ({ ...d, days: daysUntil(d.expiry_date) }))
        .filter((d) => d.days !== null && d.days <= WARN_DAYS)
        .sort((a, b) => a.days - b.days);
      setItems(list);
    }).catch(() => {});
    load();
    const t = setInterval(load, 10 * 60 * 1000);
    return () => { alive = false; clearInterval(t); };
  }, [refreshKey]);

  if (!items.length) return null;
  return (
    <div className="space-y-2" data-testid="doc-expiry-banner">
      {items.map((d) => {
        const expired = d.days < 0;
        const pendingRenewal = d.renewal?.status === "pending";
        return (
          <div
            key={d.doc_type}
            className={`rounded-2xl backdrop-blur-xl border px-4 py-3 text-white shadow-lg flex items-center gap-3 ${expired ? "bg-[#7F1D1D]/90 border-[#EF4444]/50" : "bg-[#78350F]/90 border-[#F59E0B]/50"}`}
            data-testid={`doc-expiry-banner-${d.doc_type}`}
          >
            <div className="flex-1 min-w-0">
              <div className="font-bold text-sm leading-tight">
                {LABELS[d.doc_type]} {expired ? "has expired" : d.days === 0 ? "expires today" : `expires in ${d.days} day${d.days === 1 ? "" : "s"}`}
              </div>
              <div className="text-xs opacity-90 mt-0.5">
                {pendingRenewal
                  ? "Your renewal is awaiting review."
                  : expired ? "You can't go online until a renewal is approved." : `Expiry date ${d.expiry_date}. Upload the renewal now to avoid going off the road.`}
              </div>
            </div>
            {!pendingRenewal && (
              <button
                type="button"
                onClick={() => onRenew(d.doc_type)}
                className="flex-shrink-0 rounded-full bg-white text-[#0A0A0A] text-xs font-bold px-3 py-1.5 hover:bg-white/90 transition-colors"
                data-testid={`doc-expiry-renew-btn-${d.doc_type}`}
              >
                Renew
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DocumentExpiryBanner;
